import { RelativeFile } from '@/types/common.ts';
import {
  ODS_CONTENT_TYPE,
  XLS_CONTENT_TYPE,
  XLSM_CONTENT_TYPE,
  XLSX_CONTENT_TYPE,
} from '@/utils/mimeTypes.ts';

export type UploadFileMetadata = {
  path: string;
  content_type: string | null;
};

export const stripWrappingQuotes = (value: string): string => {
  const trimmed = value.trim();
  if (
    trimmed.length >= 2 &&
    trimmed[0] === trimmed[trimmed.length - 1] &&
    ['"', "'"].includes(trimmed[0])
  ) {
    return trimmed.slice(1, -1);
  }
  return trimmed;
};

const CANONICAL_MIME_TYPES_BY_LOWERCASE: Record<string, string> = {
  [XLS_CONTENT_TYPE.toLowerCase()]: XLS_CONTENT_TYPE,
  [XLSX_CONTENT_TYPE.toLowerCase()]: XLSX_CONTENT_TYPE,
  [XLSM_CONTENT_TYPE.toLowerCase()]: XLSM_CONTENT_TYPE,
  [ODS_CONTENT_TYPE.toLowerCase()]: ODS_CONTENT_TYPE,
};

export const normalizeUploadContentType = (value: string): string => {
  const unquoted = stripWrappingQuotes(value);
  return CANONICAL_MIME_TYPES_BY_LOWERCASE[unquoted.toLowerCase()] ?? unquoted;
};

export const getSignedUploadConfig = (contentType: string | null | undefined) =>
  contentType ? { headers: { 'Content-Type': contentType } } : undefined;

export const relativeFileToUploadMetadata = (relativeFile: RelativeFile): UploadFileMetadata => ({
  path: stripWrappingQuotes(relativeFile.path),
  content_type: relativeFile.file.type ? normalizeUploadContentType(relativeFile.file.type) : null,
});
